import { JsonUtils } from '../../utils/json.util'
import { Anamnese } from './anamnese'
import { Capture } from './capture'
import { Conducts } from './conducts'
import { Diagnostics } from './diagnostics'
import { Exams } from './exams'

export enum YesNo {
    YES = "true",
    NO = "false"
}
export enum ExamTypes {
    NOT_OPTED = "Não optado",
    MAMMOGRAPHY = "Mamografia",
    ULTRASOUND = "Ultrassom",
    BIOPSY = "Biópsia",
    IMMUNOHISTOCHEMISTRY = "Imunohistoquímica",
    SHARPENING = "Aguçamento",
    SURGERY = "Cirurgia",
    MAMMOTOMY = "Mamotomia",
    PUNCTURE = "Punção",
    GENETIC_TEST = "Teste genético"

}
export enum SugeryTypes {
    QUADRANTECTOMY = "Quadrantectomia",
    QUADRANTECTOMY_RESECTION = "Quadrantectomia com ressecção do linfonodo sentinela",
    QUADRANTECTOMY_DISSECTION = "Quadrantectomia com esvaziamento axilar",
    SIMPLE_MASTECTOMY = "Mastectomia simples",
    RADICAL_MASTECTOMY = "Mastectomia radical com esvaziamento axilar",
    SEGMENTECTOMY = "Segmentectomia",
    ADENOMA_EXTIRPATION = "Extirpação de Adenoma",
    ONCPLASTIC = "Cirurgias oncoplásticas"
}

export enum StatusPatient {
    TRACKING = "Rastreamento",
    TREATMENT = "Tratamento",
    DEATH = "Óbito"
}
export enum Chemotherapy {
    ADJUVANT = "Quimioterapia adjuvante",
    NEOADJUVANT = "Quimioterapia neoadjuvante"
}

export enum HistologicalTypes {
    INVASIVE_DUCTAL_CARCINOMA = "Carcinoma Ductal Invasivo",
    CARCINOMA_DUCTAL_IN_SITU = "Carcinoma Ductal In Situ",
    INVASIVE_LOBULAR_CARCINOMA = "Carcinoma Lobular Invasivo",
    PAGET_DISEASE = "Doença de Paget",
    LOBULAR_CARCINOMA_IN_SITU = "Carcinoma Lobular In situ",
    FIBROADENOMA = "Fibroadenoma",
    GYNECOMASTIA = "Ginecomastia",
    CYST = "Cisto",
  //  OTHERS = "Outros"
}
export enum Service {
    PUBLIC = "SUS",
    PRIVATE = "Privado",
    MLDP = "MLDP"
}
export enum BiradsTypes {
    BI_RADIS0 = '0',
    BI_RADIS1 = '1',
    BI_RADIS2 = '2',
    BI_RADIS3 = '3',
    BI_RADIS4A = '4A',
    BI_RADIS4B = '4B',
    BI_RADIS4C = '4C',
    BI_RADIS5 = '5',
    BI_RADIS6 = '6'
}
export enum TypesCases {
    IN_ANALYSIS = 'Em análise',
    MALIGNANT = 'Maligno',
    BENIGN = 'Benigno'
}
export enum PatientCategorization {
    OBLIGATORY_ULTRASOUND = "Ultrassom obrigatório",
    BIOPSY = "Realização de Biópsia",
    RETURN_SUS = "Retorno ao SUS",
    CLOSED_DIAGNOSIS = "Diagnóstico Fechado",
    RETURN_SIX_MONTHS = "Retorno a cada 6 meses",
    RETURN_ONE_YEAR = "Retorno anual"
}

export enum TumorTypes {
    LUMINAL_A = "Luminal A",
    LUMINAL_B = "Luminal B",
    TRIPLE_NEGATIVE = "Triplo negativo",
    AMPLIFIED_HER2 = "HER/2 amplificado",
    HER2_NOT_AMPLIFIED = "HER/2 não amplificado"
}

export enum TumorLocation {
    QSE_MD = "QSE MD",
    QSI_MD = "QSI MD",
    QIE_MD = "QIE MD",
    QSE_ME = "QSE ME",
    QSI_ME = "QSI ME",
    QIE_ME = "QIE ME",
    QII_ME = "QII ME"
}
export enum ExamsClassification {
    MAMMOGRAPHY = "Mamografia",
    USG_MAMMARY = "USG mamária",
    PUNCTURE = "Punção",
    NEEDLING = "Agulhamento",
    IMMUNOHISTOCHEMISTRY = "Imunohistoquímica",
    CYTOPATHOLOGICAL = "Citopatológico",
    MAMMOTOMY = "Mamotomia",
    ANATOMOPATHOLOGICAL = "Anatomopatológico",
    CORE_BIOPSY = "Core biópsia",
    CONSULTATION = "Consulta",
    GENETIC_TEST = "Teste genético",
    SURGERY = "Cirurgia",
}
export enum TypesNodules {
    NOT_CONTAIN = "Impalpável",
    FIBROELASTIC = "Fibroelástica",
    HARD_CONSISTENCY = "Consistência endurecida"
}

export enum CategoryFilter {
    RETURN_SIX_MONTHS = "Retorno a cada 6 meses",
    RETURN_ONE_YEAR = "Retorno anual"
}
export enum MulticolorDischarge {
    BLACK = "Preto",
    YELLOW = "Amarelo",
    GREEN = "Verde",
    WHITE = "Branco"
}

export class FollowUp {
    private _id: string | undefined
    private _patient_id: string | undefined
    private _created_at: string | undefined
    private _finished_at: string | undefined

    // Capture
    private _capture: Capture | undefined

    // Anamnesis 
    private _anamnese: Anamnese | undefined

    // Exam
    private _exams: Exams | undefined

    // Diagnosis
    private _diagnostics: Diagnostics | undefined

    // Conduct
    private _conducts: Conducts | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }
    get patient_id(): string | undefined {
        return this._patient_id
    }

    set patient_id(value: string | undefined) {
        this._patient_id = value
    }
    get created_at(): string | undefined {
        return this._created_at
    }

    set created_at(value: string | undefined) {
        this._created_at = value
    }
    get finished_at(): string | undefined {
        return this._finished_at
    }

    set finished_at(value: string | undefined) {
        this._finished_at = value
    }
    get capture(): Capture | undefined {
        return this._capture
    }

    set capture(value: Capture | undefined) {
        this._capture = value
    }
    get anamnese(): Anamnese | undefined {
        return this._anamnese
    }

    set anamnese(value: Anamnese | undefined) {
        this._anamnese = value
    }
    get exams(): Exams | undefined {
        return this._exams
    }

    set exams(value: Exams | undefined) {
        this._exams = value
    }
    get diagnostics(): Diagnostics | undefined {
        return this._diagnostics
    }

    set diagnostics(value: Diagnostics | undefined) {
        this._diagnostics = value
    }
    get conducts(): Conducts | undefined {
        return this._conducts
    }

    set conducts(value: Conducts | undefined) {
        this._conducts = value
    }


    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): FollowUp {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        if (json.id !== undefined) {
            this.id = json.id
        }
        if (json.patient_id !== undefined) {
            this.patient_id = json.patient_id
        }
        if (json.created_at !== undefined) {
            this.created_at = json.created_at
        }
        if (json.finished_at !== undefined) {
            this.finished_at = json.finished_at
        }
        if (json.capture !== undefined) {
            this.capture = new Capture().fromJSON(json.capture)
        }
        if (json.anamnese !== undefined) {
            this.anamnese = new Anamnese().fromJSON(json.anamnese)
        }
        if (json.exams !== undefined) {
            this.exams = new Exams().fromJSON(json.exams)
        }
        if (json.diagnostics !== undefined) {
            this.diagnostics = new Diagnostics().fromJSON(json.diagnostics)
        }
        if (json.conducts !== undefined) {
            this.conducts = new Conducts().fromJSON(json.conducts)
        }

        return this
    }

    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {

            id: this.id || undefined,
            patient_id: this.patient_id || undefined,
            created_at: this.created_at || undefined,
            capture: this.capture || undefined,
            anamnese: this.anamnese || undefined,
            exams: this.exams || undefined,
            diagnostics: this.diagnostics || undefined,
            conducts: this.conducts || undefined,

        }
    }
}